// !NO MANUAL EDITING ALLOWED. CREATED BY NPM SCRIPT `codegen:localizations`.

export var TranslationKeys = /*#__PURE__*/function (TranslationKeys) {
  TranslationKeys["Greetings"] = "Greetings";
  TranslationKeys["InviteMessageTooltip"] = "InviteMessageTooltip";
  TranslationKeys["LiveNow"] = "LiveNow";
  TranslationKeys["LiveVideoStartingSoon"] = "LiveVideoStartingSoon";
  TranslationKeys["ReferralMessageTooltip"] = "ReferralMessageTooltip";
  TranslationKeys["SeeMyFavoriteProducts"] = "SeeMyFavoriteProducts";
  TranslationKeys["SponsorPhoto"] = "SponsorPhoto";
  TranslationKeys["WatchLatestVideo"] = "WatchLatestVideo";
  return TranslationKeys;
}({});